import React from 'react';

import { useChat } from '../../../lib/context/chat/ChatContext';
import { ConfirmIcon } from '../../atoms/icons/ConfirmIcon';
import { PlanCard } from '../PlanCard/PlanCard';

import styles from './PlanComponentUpdated.module.css';

export const PlanComponentUpdated: React.FC = () => {
    const { plan } = useChat();

    console.log('plan', plan)

    return (
        <div className={styles.planComponentUpdatedModal}>
            <div className={styles.planComponentUpdatedTitle}>
                <ConfirmIcon />
                <h2>
                    You have successfully <br /> modified your plan!
                </h2>
            </div>
            <div className={styles.planComponentDetails}>
                <p>
                    Your selected plan
                </p>
                <PlanCard success plan={plan} />
            </div>
        </div>
    );
};